import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import i18n from '/src/locals/i18n';

// Nucleo Icons
//import "./assets/css/nucleo-icons.css";
//import "./assets/css/nucleo-svg.css";
// Leaflet and markercluster CSS are now dynamically imported only where needed
import 'bootstrap/dist/css/bootstrap.min.css'

import './assets/css/flag-icons-custom.css'
import './assets/css/bootstrap-icons-custom.css';

// Bootstrap JS
import "bootstrap/dist/js/bootstrap.bundle.min.js"

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
library.add(fas, fab, far)

// MATERIAL KIT
import materialKit from "./material-kit";

// 🧠 Head Management
import { createHead } from '@vueuse/head';

const app = createApp(App);
const head = createHead();

// 👉 Control de cookies: cargar GA solo si acepta "all"
const isLocalhost = window.location.hostname === 'localhost';
const GA_ID = 'G-H389FYRHS7';

// 1. Verificamos si ya existe el script o si estamos en local
if (!isLocalhost && !document.getElementById('google-analytics-script')) {
  
  const gaScript = document.createElement('script');
  gaScript.id = 'google-analytics-script'; // ID para evitar duplicados
  gaScript.async = true;
  gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(gaScript);

  window.dataLayer = window.dataLayer || [];
  function gtag(){ window.dataLayer.push(arguments); }
  window.gtag = gtag;

  gtag('js', new Date());
  // Desactivamos el page_view automático para que el Router mande el único hit real
  gtag('config', GA_ID, { send_page_view: false });

  if (router) {
    router.afterEach((to) => {
      gtag('config', GA_ID, { 
        page_path: to.fullPath,
        location: window.location.origin + to.fullPath 
      });
    });
  }
}

app.component('font-awesome-icon', FontAwesomeIcon);
app.use(createPinia());
app.use(router);
app.use(materialKit);
app.use(i18n);
app.use(head);
app.mount("#app");
